import {md5} from 'js-md5'
import {sha256} from 'js-sha256'
// @ts-expect-error no type definitions available for evaporate
import Evaporate from 'evaporate'
import {
  AWS_BUCKET,
  AWS_KEY,
  AWS_REGION,
  AWS_SINGER,
} from '../constants/apiConstants'

interface IUploadOptions {
  file: File
  filePrefix?: string
  withUserFullName?: string
  callback?: (url: string) => void
  uploadProgress?: (data: {progress: number; name: string}) => void
  id?: string
}

interface IUploadResult {
  url: string
  fileName: string
}

async function uploadDocumentWithSignerToAWS(
  options: IUploadOptions = {} as IUploadOptions,
): Promise<void> {
  const {filePrefix, withUserFullName, callback} = options
  const {file} = options
  const config = {
    signerUrl: `${AWS_SINGER}`,
    aws_key: `${AWS_KEY}`,
    bucket: `${AWS_BUCKET}`,
    awsRegion: `${AWS_REGION}`,
    cloudfront: true,
    computeContentMd5: true,
    cryptoMd5Method: (data: string | Uint8Array): string => md5.base64(data),
    cryptoHexEncodedHash256: (data: string | Uint8Array): string =>
      sha256(data),
  }
  const fileNameParams = file.name.split('.')
  const extension = fileNameParams.pop()
  const timestamp = Date.now()

  let fileName = `${
    filePrefix ? `${filePrefix}-` : 'file-'
  }${timestamp}.${extension}`

  if (withUserFullName) {
    fileName = `${
      filePrefix ? `${filePrefix}-` : ''
    }${withUserFullName}.${extension}`
  }

  let type = 'application/' + file.type.split('/').slice(-1)[0]
  if (type === 'application/pdf') {
    type = 'octet-stream'
  }

  if (type === 'application/svg+xml') {
    type = 'image/svg+xml'
  }

  const properties = {
    name: `${fileName}`,
    file,
    contentType: `${type}`,
    xAmzHeadersAtInitiate: {'x-amz-acl': 'public-read'},
  }

  const evaporate = await Evaporate.create(config)
  await evaporate.add({
    ...properties,
    complete: (_xhr: {responseURL: string}) => {
      const {responseURL} = _xhr
      const [URL] = responseURL.split('?')
      if (typeof callback === 'function') {
        callback(URL)
      }
    },
    error: (err: unknown) => {
      console.log('ERROR >>> ', err)
    },
    warn: (err: unknown) => {
      console.log('WARNING >>> ', err)
    },
    // progress: (progressValue, stats) => {
    //   const progress = Math.round(
    //     ((stats.fileSize - stats.remainingSize) * 100) / stats.fileSize
    //   );
    //   uploadProgress({ progress, name: file.name });
    // },
  })
}

export async function uploadDocumentToAWS(
  options: IUploadOptions = {} as IUploadOptions,
): Promise<IUploadResult> {
  const {uploadProgress: _uploadProgress, ...rest} = options
  return new Promise(resolve => {
    const OPTIONS: IUploadOptions = {
      ...rest,
      callback: (url: string) => {
        const fileName = url.split('/').pop() || ''
        resolve({url, fileName})
      },
    }

    uploadDocumentWithSignerToAWS(OPTIONS)
  })
}
